const VERSION = "8.0.0";
export {
  VERSION
};
